import { ACTIVE, INACTIVE, TERMINATED, RESTRICTED_STATUSES } from "../../enums/clientStatusTypes";
import { MANUAL } from "../../enums/billingPeriodTypes";
import { TED_DESJARDINS } from "../../enums/synchronizationOptions";

export const commonMajorCardCriteria = (clientBillingPeriodType, syncType) => {
    return (
        clientBillingPeriodType !== MANUAL.value &&
        syncType !== TED_DESJARDINS.value
    );
};

export const canGenerateMajorCards = (clientStatusType, clientBillingPeriodType, syncType) => {
    return (
        !RESTRICTED_STATUSES.includes(clientStatusType) &&
        commonMajorCardCriteria(clientBillingPeriodType, syncType)
    );
};

export const canSendMajorCards = (clientStatusType, clientBillingPeriodType, syncType, isMintEnabled) => {
    return (
        clientStatusType === ACTIVE.value &&
        commonMajorCardCriteria(clientBillingPeriodType, syncType) && isMintEnabled
    );
};

export const hasMajorCardsFeature = (clientStatusType, clientBillingPeriodType, syncType) => {
    return (
        !RESTRICTED_STATUSES.includes(clientStatusType) &&
        commonMajorCardCriteria(clientBillingPeriodType, syncType)
    );
};



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/members/majorCardsCriteriaHelper.js